import { combineReducers, createStore} from 'redux';
import app from './app';
import session from './session';
import messageCenter from './messageCenter';
import dashboard from './dashboard';
import clients from './clients';
import client from './client';
import contacts from './contacts';
import contact from './contact';
import candidates from './candidates';
import candidate from './candidate';
import events from './events';
import me from './me';
import search from './search';
import emails from './emails';
import contactCandidateList from './contactCandidateList';
import candidateContactList from './candidateContactList';
import invoices from './invoices';
import offers from './offers';

const reducers = combineReducers ({
  app,
  session,
  messageCenter,
  dashboard,
  clients,
  client,
  contacts,
  contact,
  candidates,
  candidate,
  events,
  me,
  search,
  emails,
  contactCandidateList,
  candidateContactList,
  invoices,
  offers,
});

export const store = createStore(reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
